// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="p-6">Verificando sesión...</div>;
  }

  if (!user) {
    // Guardado en sessionStorage (no solo en router state) porque el login
    // con Microsoft sale del SPA a un dominio externo y vuelve -- el state
    // de React Router no sobrevive ese viaje redondo, sessionStorage sí.
    const destino = `${location.pathname}${location.search || ''}`;
    if (destino && destino !== '/login') {
      sessionStorage.setItem('hd_post_login_redirect', destino);
    }
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  // Si hay user, renderiza la ruta hija
  return <Outlet />;
}
